import { Table } from "antd";
import React, { FC, useMemo, useEffect } from "react";
import { IJob, IProjectDetails } from "../helper";
import { ProjectsColumns } from "../helper/misc";
import { useNavigate, useSearchParams } from "react-router-dom";

interface Props {
  list: Array<IJob>;
}

export const ProjectList: FC<Props> = ({ list }) => {
  
  const navigate = useNavigate();
  const dataSource: IProjectDetails[] = useMemo(
    () =>
      list.map((job) => ({
        _id: job._id,
        name: job.companyName,
        positionTitle: job.positionTitle,
        priority: job.priority?.toString(),
        applicantsCount: job.submittedApplicationsCount ?? job.totalApplicants ?? 0,
        completionPercentage: job.completionPercentage,
        managers: job.managers,
        createdBy: job.createdBy,
        recruiterName: job.recruiterName,
        totalApplicants: job.totalApplicants ?? 0,
      })),
    [list]
  );

  const handleChange = (id?: string) => {
    if (id) setSearchParams((params) => {
      params.set("job", id);
      return params;
    });
  };

  const columns = useMemo(() => ProjectsColumns(handleChange), [handleChange]);

  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (list.length > 0) {
      console.log("Sample job object:", list[0]);
    }
  }, [list]);

  return (
    <Table dataSource={dataSource} columns={columns} rowKey="_id" pagination={false} />
  );
};

export default ProjectList;
